/* tslint:disable */
/* eslint-disable */
/**
 * AGAIN-AGAIN API
 * backend api for tracking container movement for again-again
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Reward
 */
export interface Reward {
    /**
     * 
     * @type {string}
     * @memberof Reward
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof Reward
     */
    readonly title: string;
    /**
     * 
     * @type {string}
     * @memberof Reward
     */
    promotion: string;
    /**
     * 
     * @type {Date}
     * @memberof Reward
     */
    redeemedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Reward
     */
    expireAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Reward
     */
    site?: string | null;
}

export function RewardFromJSON(json: any): Reward {
    return RewardFromJSONTyped(json, false);
}

export function RewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): Reward {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'promotion': json['promotion'],
        'redeemedAt': !exists(json, 'redeemed_at') ? undefined : (json['redeemed_at'] === null ? null : new Date(json['redeemed_at'])),
        'expireAt': (new Date(json['expire_at'])),
        'site': !exists(json, 'site') ? undefined : json['site'],
    };
}

export function RewardToJSON(value?: Reward | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'promotion': value.promotion,
        'redeemed_at': value.redeemedAt === undefined ? undefined : (value.redeemedAt === null ? null : value.redeemedAt.toISOString()),
        'expire_at': (value.expireAt.toISOString()),
        'site': value.site,
    };
}


